const global = {
  state: {
    contactUsVisible: true
  },
  mutations: {
    SET_CONTACT_US_VISIBLE(state, visible) {
      state.contactUsVisible = visible
    }
  }
}
export default global
